// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-logingraph {
  display: flex;
  margin-top: 5%;
  gap: 20px;
  flex-direction: row; /* Arrange cards in a row */
  justify-content: center;
}
.admindashboardpiecharts {
  display: flex;
  flex-direction: row; /* Arrange cards in a row */
  justify-content: center; /* Center the cards horizontally */
  align-items: center; /* Align them vertically */
  gap: 25px; /* Space between cards */
  width: 100%; /* Ensures it spans the full width */
  max-width: 1200px; /* Prevents stretching on larger screens */
  margin: 1% auto; /* Centers the container */
  margin-top: 2.5%;
}

.dashboard-card-containers {
  display: flex;
  margin-top: 1%;
  margin-left: 0%;
  gap: 5px;
  flex-direction: row; /* Arrange cards in a row */
  justify-content: center; /* Center the cards horizontally */
}

.dashboard-Projecttable {
  display: flex;
  margin-top: 5%;
  gap: 20px;
  flex-direction: row; /* Arrange cards in a row */
  justify-content: center; /* Center the cards horizontally */
}
`, "",{"version":3,"sources":["webpack://./src/components/MyDashboard/MyDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,SAAS;EACT,mBAAmB,EAAE,2BAA2B;EAChD,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB,EAAE,2BAA2B;EAChD,uBAAuB,EAAE,kCAAkC;EAC3D,mBAAmB,EAAE,0BAA0B;EAC/C,SAAS,EAAE,wBAAwB;EACnC,WAAW,EAAE,oCAAoC;EACjD,iBAAiB,EAAE,0CAA0C;EAC7D,eAAe,EAAE,0BAA0B;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,QAAQ;EACR,mBAAmB,EAAE,2BAA2B;EAChD,uBAAuB,EAAE,kCAAkC;AAC7D;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;EACT,mBAAmB,EAAE,2BAA2B;EAChD,uBAAuB,EAAE,kCAAkC;AAC7D","sourcesContent":[".dashboard-logingraph {\n  display: flex;\n  margin-top: 5%;\n  gap: 20px;\n  flex-direction: row; /* Arrange cards in a row */\n  justify-content: center;\n}\n.admindashboardpiecharts {\n  display: flex;\n  flex-direction: row; /* Arrange cards in a row */\n  justify-content: center; /* Center the cards horizontally */\n  align-items: center; /* Align them vertically */\n  gap: 25px; /* Space between cards */\n  width: 100%; /* Ensures it spans the full width */\n  max-width: 1200px; /* Prevents stretching on larger screens */\n  margin: 1% auto; /* Centers the container */\n  margin-top: 2.5%;\n}\n\n.dashboard-card-containers {\n  display: flex;\n  margin-top: 1%;\n  margin-left: 0%;\n  gap: 5px;\n  flex-direction: row; /* Arrange cards in a row */\n  justify-content: center; /* Center the cards horizontally */\n}\n\n.dashboard-Projecttable {\n  display: flex;\n  margin-top: 5%;\n  gap: 20px;\n  flex-direction: row; /* Arrange cards in a row */\n  justify-content: center; /* Center the cards horizontally */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
